import { Chip } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import React, { FC } from 'react';

export const OnlineChip: FC = () => (
  <Chip icon={<CheckIcon />} label="Connecté" color="primary" variant="outlined"></Chip>
);
